import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueAnimate from 'vue-animate-scroll'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

/* import * as VueGoogleMaps from 'vue2-google-maps' */

/* Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCTPcjriBW2XnL4l9C1PPzYQhNlR2K-7fc',
    libraries: 'places',
  },
}) */
Vue.use(VueAnimate)
Vue.use(VueSweetalert2);

Vue.config.productionTip = false;

new Vue({

  router,
  store,
  render: h => h(App)
}).$mount("#app");